export const scrollIntoView = (hash: string): void => {
  window.history.pushState(null, null, hash)
  document.querySelector(hash).scrollIntoView({behavior: 'smooth'})
}
